import styled from "styled-components";

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;

  .modal-left {
    display: flex;
    align-items: center;
    gap: 10px;

    .modal-left-info {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background-color: #fff0f0;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        color: #f00000;
      }
    }

    h3 {
      margin: 0;
      padding: 0;
      font-size: 18px;
      font-weight: 600;
      color: #171717;
    }
  }
`;

export const ModelContent = styled.div`
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 400;
  color: #171717;

  border-bottom: 1px solid #edeef2;
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  background-color: #f5f5f5;
  margin-top: 16px;

  button {
    border: 1px solid #1271a6;
    border-radius: 2px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    font-family: "Inter";
    padding: 8px 20px;

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }

  button:nth-child(1) {
    background-color: transparent;
    color: #1271a6;
  }

  button:nth-child(2) {
    background-color: #1271a6;
    color: #fff;
  }
`;
